import { Routes } from '@angular/router';
import { roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const employeesRoutes: Routes = [
  {
    path: 'employees',
    title: 'Mitarbeiter Übersicht',
    loadComponent: () =>
      import('./employees-list/employees-list').then(m => m.EmployeesListComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.EMPLOYEE_READ, UserRoles.EMPLOYEE_WRITE] },
  },
  {
    path: 'employees/new',
    title: 'Neuer Mitarbeiter',
    loadComponent: () => import('./employee-form/employee-form').then(m => m.EmployeeFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.EMPLOYEE_WRITE] },
  },
  {
    path: 'employees/:id/edit',
    title: 'Mitarbeiter bearbeiten',
    loadComponent: () => import('./employee-form/employee-form').then(m => m.EmployeeFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.EMPLOYEE_WRITE] },
  },
  {
    path: 'employee-absences',
    title: 'Abwesenheitskalender',
    loadComponent: () =>
      import('./employee-absences-calendar/employee-absences-calendar').then(
        m => m.EmployeeAbsencesCalendarComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.EMPLOYEE_READ, UserRoles.EMPLOYEE_WRITE] },
  },
];
